<template>
  <div v-if="items.length" class="gf">
    <button
      v-for="(item, index) in items"
      :key="item.key"
      type="button"
      class="gf-item"
      :aria-label="(item.type === 'youtube' ? 'Reproducir vídeo ' : 'Ver imagen ') + (index + 1) + ' de ' + items.length"
      @click="abrir(index)"
    >
      <img v-img-fallback :src="item.thumb" :alt="item.caption || ''" loading="lazy" decoding="async" />
      <span v-if="item.type === 'youtube'" class="gf-play">
        <span class="material-symbols-outlined">play_arrow</span>
      </span>
      <span v-else class="gf-zoom">
        <span class="material-symbols-outlined">zoom_in</span>
      </span>
    </button>

    <LightBox
      ref="lightbox"
      :show-caption="true"
      :show-light-box="false"
      :media="media"
      :interfaceHideTime="300000"
    />
  </div>
</template>

<script>
import axios from "@/directives/axios.js";
import { track } from "@/directives/analitica.js";
import LightBox from "vue-it-bigger";
import("vue-it-bigger/dist/vue-it-bigger.min.css");

function youTubeGetID(url) {
  const parts = url.replace(/(>|<)/gi, "").split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  return parts[2] !== undefined ? parts[2].split(/[^0-9a-z_-]/i)[0] : url;
}

export default {
  name: "gridFotos",
  components: { LightBox },
  props: {
    // Id de galería a cargar desde la API (opcional)
    id: [String, Number],
    // Lista ya cargada: elementos con "urlImage" o "imagen", y opcionalmente "titulo"/"description"
    listaImagenes: Array,
  },
  data() {
    return {
      cargadas: [],
      base: this.$media,
    };
  },
  computed: {
    fuente() {
      return this.listaImagenes || this.cargadas;
    },
    // Formato único para la rejilla y el lightbox: así el índice pulsado coincide siempre
    items() {
      return (this.fuente || [])
        .map((el, i) => {
          const url = el.urlImage || el.imagen || "";
          const caption = [el.titulo, el.description].filter(Boolean).join(" · ");
          if (!url) return null;
          if (url.includes("youtube") || url.includes("youtu.be")) {
            const vid = youTubeGetID(url);
            return {
              key: i + url,
              type: "youtube",
              id: vid,
              thumb: `https://img.youtube.com/vi/${vid}/hqdefault.jpg`,
              caption,
            };
          }
          if (url.startsWith("http")) {
            return { key: i + url, type: "image", thumb: url, src: url, caption };
          }
          return {
            key: i + url,
            type: "image",
            thumb: `${this.base}/img/minGallery/${url}`,
            src: `${this.base}/img/gallery/${url}`,
            caption,
          };
        })
        .filter(Boolean);
    },
    media() {
      return this.items.map((it) =>
        it.type === "youtube"
          ? { type: "youtube", id: it.id, thumb: it.thumb, caption: it.caption }
          : { type: "image", thumb: it.thumb, src: it.src, caption: it.caption }
      );
    },
  },
  mounted() {
    if (this.id && !this.listaImagenes) this.cargar();
  },
  methods: {
    async cargar() {
      try {
        const { data } = await axios.get(`/imagenes/galeriaImagenes?id=${this.id}`);
        this.cargadas = (data.galerias && data.galerias.imagenes) || [];
        this.$emit("loaded", data.galerias || null);
      } catch (e) {
        this.cargadas = [];
      }
    },
    abrir(index) {
      const item = this.items[index] || {};
      track("ver_foto", {
        tipo: item.type === "youtube" ? "video" : "foto",
        posicion: index + 1,
        total: this.items.length,
        origen: this.$route.name,
        item_id: this.$route.query.id ? String(this.$route.query.id) : undefined,
      });
      this.$refs.lightbox.showImage(index);
    },
  },
};
</script>

<style scoped>
.gf {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
}

.gf-item {
  position: relative;
  aspect-ratio: 4 / 3;
  padding: 0;
  overflow: hidden;
  border: 0;
  border-radius: 14px;
  background: var(--sd-surface-2);
  cursor: zoom-in;
}

.gf-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.gf-item:hover img {
  transform: scale(1.06);
}

.gf-item:focus-visible {
  outline: 3px solid var(--sd-primary);
  outline-offset: 3px;
}

.gf-zoom,
.gf-play {
  position: absolute;
  display: grid;
  place-items: center;
}

.gf-zoom {
  inset: 0;
  background: rgba(11, 18, 33, 0.35);
  opacity: 0;
  transition: opacity 0.25s;
}

.gf-item:hover .gf-zoom,
.gf-item:focus-visible .gf-zoom {
  opacity: 1;
}

.gf-zoom .material-symbols-outlined {
  font-size: 36px;
  color: #fff;
}

.gf-play {
  top: 50%;
  left: 50%;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(220, 38, 38, 0.92);
  transform: translate(-50%, -50%);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
  transition: transform 0.2s;
}

.gf-item:hover .gf-play {
  transform: translate(-50%, -50%) scale(1.08);
}

.gf-play .material-symbols-outlined {
  font-size: 36px;
  color: #fff;
}

@media (max-width: 520px) {
  .gf {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .gf-item {
    border-radius: 10px;
  }
}
</style>
